import { render, staticRenderFns } from "./events-highlights.vue?vue&type=template&id=23f493b9&scoped=true&"
import script from "./events-highlights.vue?vue&type=script&lang=js&"
export * from "./events-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f493b9",
  null
  
)

export default component.exports